import React from 'react';
import './LinkCard.scss';
import Typography from 'src/components/common/typography/Typography';
import { CrossIcon } from 'src/components/common/common.icons';
import addHttps from 'src/utils/addhttps/addhttps';

function LinkCard({ metadata, linkRef, clickable = true, removable = false, onRemove, link }: any) {
    const originUrl = link || getBaseUrl(metadata?.url);
    return (
        <div className='cardMain' ref={linkRef}>
            {removable && <CrossIcon className='cardMain__cross-icon' color='red' onClick={() => onRemove && onRemove()} />}
            <a
                href={clickable && metadata?.url ? addHttps(originUrl) : '#'}
                {...(clickable ? {
                    target: "_blank",
                    rel: "noopener noreferrer"
                } : {})}
                className='cardRedirect'
            >
                {metadata?.image?.url && <div className='imgBox'>
                    <img src={metadata?.image?.url} alt="img" />
                </div>}
                <div className='contentBox'>
                    <Typography as="p" variant="body-1" className='typography__ellipsis' fontWeight="semiBold">
                        {metadata?.title || ''}
                    </Typography>{' '}
                    <Typography as="p" variant="body-2" style={{ wordBreak: 'break-word' }} fontWeight="regular" title={originUrl}>
                        {originUrl?.length > originUrl?.slice(0, 40)?.length ? originUrl?.slice(0, 40) + '...' : originUrl}
                    </Typography>
                </div>
            </a>
        </div>
    )
}

export default LinkCard

const getBaseUrl = (url: string): string => {
    try {
        const parsedUrl = new URL(url);
        return parsedUrl.origin; // Returns the protocol + hostname
    } catch (error) {
        console.error('Invalid URL:', url);
        return url; // Return the original URL if it's invalid
    }
};
